import React, { useState, useEffect } from "react";
import axios from "axios";
import "./Forgot.css";

export default function Forgot() {
  const [step, setStep] = useState(1);
  const [email, setEmail] = useState("");
  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const [newPassword, setNewPassword] = useState("");
  const [message, setMessage] = useState("");
  const [lang, setLang] = useState(localStorage.getItem("lang") || "en");
  const [text, setText] = useState({});

  const baseURL = process.env.REACT_APP_API_URL;

  const translations = {
    en: {
      title: "Forgot Password",
      emailPlaceholder: "Enter your email",
      sendOtp: "Send OTP",
      verifyOtp: "Verify OTP",
      newPasswordPlaceholder: "Enter new password",
      resetPassword: "Reset Password",
      otpFail: "Failed to send OTP.",
      otpVerifyFail: "OTP verification failed.",
      resetFail: "Password reset failed.",
      resetSuccess: "Password reset successful.",
    },
    bn: {
      title: "পাসওয়ার্ড ভুলে গেছেন",
      emailPlaceholder: "আপনার ইমেইল দিন",
      sendOtp: "ওটিপি পাঠান",
      verifyOtp: "ওটিপি যাচাই করুন",
      newPasswordPlaceholder: "নতুন পাসওয়ার্ড দিন",
      resetPassword: "পাসওয়ার্ড রিসেট করুন",
      otpFail: "ওটিপি পাঠানো ব্যর্থ হয়েছে।",
      otpVerifyFail: "ওটিপি যাচাই ব্যর্থ হয়েছে।",
      resetFail: "পাসওয়ার্ড রিসেট ব্যর্থ হয়েছে।",
      resetSuccess: "পাসওয়ার্ড সফলভাবে রিসেট হয়েছে।",
    },
  };

  // Update text when lang changes
  useEffect(() => {
    setText(translations[lang]);
  }, [lang]);

  // Optional: Listen for localStorage changes from other tabs
  useEffect(() => {
    const handleStorageChange = () => {
      const newLang = localStorage.getItem("lang") || "en";
      setLang(newLang);
    };
    window.addEventListener("storage", handleStorageChange);
    return () => window.removeEventListener("storage", handleStorageChange);
  }, []);

  const handleEmailSubmit = async (e) => {
    e.preventDefault();
    setMessage("");
    try {
      const res = await axios.post(`${baseURL}/forgot-password`, { email });
      if (res.data.error) {
        setMessage(res.data.msg);
      } else {
        setMessage(res.data.msg);
        setStep(2);
      }
    } catch (err) {
      setMessage(err.response?.data?.msg || text.otpFail);
    }
  };

  const handleOTPChange = (val, idx) => {
    const updatedOtp = [...otp];
    updatedOtp[idx] = val.slice(0, 1);
    setOtp(updatedOtp);

    if (val && idx < otp.length - 1) {
      const nextInput = document.getElementById(`otp-${idx + 1}`);
      if (nextInput) nextInput.focus();
    }
  };

  const handleOtpVerify = async (e) => {
    e.preventDefault();
    setMessage("");
    const otpCode = otp.join("");
    try {
      const res = await axios.post(`${baseURL}/verify-otp`, {
        email,
        otp: otpCode,
      });
      if (res.data.error) {
        setMessage(res.data.msg);
      } else {
        setMessage(res.data.msg);
        setStep(3);
      }
    } catch (err) {
      setMessage(err.response?.data?.msg || text.otpVerifyFail);
    }
  };

  const handleResetPassword = async (e) => {
    e.preventDefault();
    setMessage("");
    try {
      const res = await axios.post(`${baseURL}/reset-password`, {
        email,
        new_password: newPassword,
      });
      if (res.data.error) {
        setMessage(res.data.msg);
      } else {
        setMessage(text.resetSuccess);
        setStep(1);
        setEmail("");
        setOtp(["", "", "", "", "", ""]);
        setNewPassword("");
      }
    } catch (err) {
      setMessage(err.response?.data?.msg || text.resetFail);
    }
  };

  return (
    <div className={`forgot-container ${lang === "bn" ? "bn-font" : ""}`}>
      <h2 className="forgot-title">{text.title}</h2>
      {message && <p className="forgot-message">{message}</p>}

      {step === 1 && (
        <form onSubmit={handleEmailSubmit} className="forgot-form">
          <input
            type="email"
            placeholder={text.emailPlaceholder}
            className="input-field"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
          <button type="submit">{text.sendOtp}</button>
        </form>
      )}

      {step === 2 && (
        <form onSubmit={handleOtpVerify} className="forgot-form">
          <div className="forgot-otp-container">
            {otp.map((digit, idx) => (
              <input
                key={idx}
                id={`otp-${idx}`}
                type="text"
                className="forgot-otp-input"
                maxLength="1"
                value={digit}
                onChange={(e) => handleOTPChange(e.target.value, idx)}
                required
              />
            ))}
          </div>
          <button type="submit">{text.verifyOtp}</button>
        </form>
      )}

      {step === 3 && (
        <form onSubmit={handleResetPassword} className="forgot-form">
          <input
            type="password"
            placeholder={text.newPasswordPlaceholder}
            className="input-field"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            required
          />
          <button className="forgot-button" type="submit">
            {text.resetPassword}
          </button>
        </form>
      )}
    </div>
  );
}
